import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEprPackagingActivity implements BaseEnumType {
  private static allValues: EnumEprPackagingActivity[] = []; // make sure this is top-most
  
  public static suppliedUnderYourBrand = new EnumEprPackagingActivity(0, "SuppliedUnderYourBrand", "enum_epr_packaging_activity_supplied_under_your_brand");
  public static packedOrFilledUnbranded = new EnumEprPackagingActivity(1, "PackedOrFilledUnbranded", "enum_epr_packaging_activity_packed_or_filled_unbranded");
  public static imported = new EnumEprPackagingActivity(2, "Imported", "enum_epr_packaging_activity_imported");
  public static suppliedAsEmpty = new EnumEprPackagingActivity(3, "SuppliedAsEmpty", "enum_epr_packaging_activity_supplied_as_empty");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEprPackagingActivity.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isSuppliedUnderYourBrand() { return this === EnumEprPackagingActivity.suppliedUnderYourBrand; }
  public isPackedOrFilledUnbranded() { return this === EnumEprPackagingActivity.packedOrFilledUnbranded; }
  public isImported() { return this === EnumEprPackagingActivity.imported; }
  public isSuppliedAsEmpty() { return this === EnumEprPackagingActivity.suppliedAsEmpty; }

  public static getValues(): readonly EnumEprPackagingActivity[] {
    return EnumEprPackagingActivity.allValues;
  }

  public static getValuesExcept0(): readonly EnumEprPackagingActivity[] {
    return EnumEprPackagingActivity.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEprPackagingActivity {
    const found = EnumEprPackagingActivity.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEprPackagingActivity - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEprPackagingActivity): EnumEprPackagingActivity {
    const found = name ? EnumEprPackagingActivity.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEprPackagingActivity - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEprPackagingActivity>): boolean {
    return this.key === other?.key;
  }
}